import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-learnset-widget',
  templateUrl: './learnset-widget.component.html',
  styleUrls: ['./learnset-widget.component.scss'],
  standalone: false
})
export class LearnsetWidgetComponent {

  @Input() learnset: any;

  constructor() {}

  ngOnInit() {}

}
